import { RegisteredComponent } from "@builder.io/sdk-react";

export const evolutionTabNavigationBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Evolution Tab Navigation",
  image:
    "https://icons.veryicon.com/png/o/photographic/component-design/navigation-135.png",
  inputs: [],
  requiresParent: {
    message:
      "This component must be nested within the Horizontal Tab component",
    component: "Horizontal Tab",
  },
};
